import React from 'react';

import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';

import ResponseSchemaPanel from './ResponseSchemaPanel';
import TEXTS from './texts';
import type { AvailableTool } from './types';

// Standalone, read-only dialog that previews a tool's expected response schema. Separate from the
// add/edit config dialog on purpose: the response contract is owned by FiveSigma (nothing to edit
// here), so it gets its own "view" affordance in the table rather than crowding the edit form.
const ResponseSchemaDialog: React.FC<{ tool: AvailableTool; onClose: () => void }> = ({ tool, onClose }) => (
  <CardDialog
    isDialog
    open
    fullWidth
    maxWidth="sm"
    title={TEXTS.responseSchema.dialogTitle(tool.tool_title)}
    onClose={onClose}
    footerActions={
      <Button color="primary" onClick={onClose}>
        {TEXTS.close}
      </Button>
    }
  >
    <ResponseSchemaPanel tool={tool} />
  </CardDialog>
);

export default ResponseSchemaDialog;
